/*
 * @Author: your name
 * @Date: 2019-12-19 09:52:52
 * @LastEditTime : 2021-08-16 13:37:47
 * @LastEditors  : jiangeryang
 * @Description: In User Settings Edit
 * @FilePath     : /club/src-client/util/cookie.ts
 */
class Cookie {
    // let domain = '.lixiang.com';
    public set = (name, value) => {
        let domain = '';
        const currentDomain = window.location.host;
        if (currentDomain.indexOf('.lixiang.com') !== -1) {
            //非本地开发时
            domain = '.lixiang.com';
        }
        const Days = 30;
        const exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${escape(
            value
        )};expires=${exp.toUTCString()};domain=${domain};`;
    };
    public getCookie(name) {
        // tslint:disable-next-line:one-variable-per-declaration
        const cookieReq = '(^| )' + name + '=([^;]*)(;|$)'; // 匹配cookie value字符串值
        const reg = new RegExp(cookieReq);
        const arr = document.cookie.match(reg);
        // tslint:disable-next-line:no-conditional-assignment
        if (arr) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
}

export default new Cookie();
